<template>
<div class="chapter">
<div class="inner_page">
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<h1 class="block_1" id="toc_id_1">About the Author</h1>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_2">Growing up near London, Carley-Ann Osborn has always had a love of books and especially loved the ones that take you on a character’s journey through their eyes. Writing was more for her own entertainment in her youth but was left on the back burner as a young adult. It wasn’t until her mid-30s that the love for reading and writing came back into her life, and she hasn’t been able to stop since.</p>
<p class="block_3" id="calibre_pb_0"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_000.vue?520a996c